import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceListItemNameFragment = { readonly __typename?: 'SyncablePriceListItemName', readonly id: string, readonly itemId: string, readonly language: Types.PriceableItemLanguage, readonly name: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPriceListItemNamePullQueryVariables = Types.Exact<{
  input: Types.PullPriceListItemNameInput;
}>;


export type SyncPriceListItemNamePullQuery = { readonly __typename?: 'Query', readonly pullPriceListItemName: { readonly __typename?: 'PullPriceListItemNameResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePriceListItemName', readonly id: string, readonly itemId: string, readonly language: Types.PriceableItemLanguage, readonly name: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceListItemNameFragmentDoc = gql`
    fragment WholeSyncablePriceListItemName on SyncablePriceListItemName {
  id
  itemId
  language
  name
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPriceListItemNamePullDocument = gql`
    query SyncPriceListItemNamePull($input: PullPriceListItemNameInput!) {
  pullPriceListItemName(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePriceListItemName
    }
  }
}
    ${WholeSyncablePriceListItemNameFragmentDoc}`;

/**
 * __useSyncPriceListItemNamePullQuery__
 *
 * To run a query within a React component, call `useSyncPriceListItemNamePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceListItemNamePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPriceListItemNamePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceListItemNamePullQuery(baseOptions: Apollo.QueryHookOptions<SyncPriceListItemNamePullQuery, SyncPriceListItemNamePullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPriceListItemNamePullQuery, SyncPriceListItemNamePullQueryVariables>(SyncPriceListItemNamePullDocument, options);
      }
export function useSyncPriceListItemNamePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPriceListItemNamePullQuery, SyncPriceListItemNamePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPriceListItemNamePullQuery, SyncPriceListItemNamePullQueryVariables>(SyncPriceListItemNamePullDocument, options);
        }
export type SyncPriceListItemNamePullQueryHookResult = ReturnType<typeof useSyncPriceListItemNamePullQuery>;
export type SyncPriceListItemNamePullLazyQueryHookResult = ReturnType<typeof useSyncPriceListItemNamePullLazyQuery>;
export type SyncPriceListItemNamePullQueryResult = Apollo.QueryResult<SyncPriceListItemNamePullQuery, SyncPriceListItemNamePullQueryVariables>;